export interface BatteryGradeDataItem {
  grade: string;
  scoreLabel: string;
  exampleScore: number | null;
}

export const BatteryGradesData: BatteryGradeDataItem[] = [
  {
    grade: "A",
    scoreLabel: "90-100",
    exampleScore: 90,
  },
  {
    grade: "B",
    scoreLabel: "80-89",
    exampleScore: 80,
  },
  {
    grade: "C",
    scoreLabel: "70-79",
    exampleScore: 70,
  },
  {
    grade: "D",
    scoreLabel: "60-69",
    exampleScore: 60,
  },
  {
    grade: "E",
    scoreLabel: "50-59",
    exampleScore: 50,
  },
  {
    grade: "X",
    scoreLabel: "Below 50",
    exampleScore: 45,
  },
];
